module.exports = __webpack_public_path__ + "ug.svg?8bcdae8b37a015a0870777d0b1e61fae";